<script> 
  export default {
    name: 'FormControl'
  }
</script>

<template>
  <div class="FormControl">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .FormControl {
    --form-gap: .5rem;
    --label-width: 120px;

    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    gap: var(--form-gap);

    .FormLabel {
      margin-bottom: .25rem;
    }
  }
</style>